export function StudentLimitDecreasedTemplate() {
	return <div className='free-extra-students' data-bind='var: {step: $data}'>
        <div className='clearfix'>
            To decrease the student limit without renewing your subscription, please contact <a href='mailto:support@esgisoftware.com'>support@esgisoftware.com</a>
        </div>
        <div className='clearfix' style={{marginTop: '15px'}}>
            <button className='btn btn-cancel pull-left' data-bind='click: view.cancel'>Cancel</button>
        </div>
    </div>;
}